import React, { ReactNode } from 'react';
import { Col, Row } from 'antd';
import { Colors, FontSize, FontWeight, LineHeight } from '@common/tokens';
import { QuickArticlesCard } from './_quick-articles-card';
import { QUICK_ARTICLES } from './_quick-articles-static-data';
import { cropList, shuffleList } from './_quick-articles-section-service';
import { iterationMap } from 'works/legacy/services/iteration-service';
import { useCurrentMembership } from '@identity/hooks';

const ARTICLES_COUNT = 6;

export function QuickArticlesSection() {
  const currentMembership = useCurrentMembership();

  const loading = !currentMembership;

  const filteredArticles = QUICK_ARTICLES.filter(
    (article) =>
      currentMembership[
        article.necessaryPermission as keyof typeof currentMembership
      ] || !article.necessaryPermission
  );

  const shuffledArticles = shuffleList(filteredArticles);
  const croppedArticles = cropList(shuffledArticles, ARTICLES_COUNT);

  return (
    <div className="quick-articles-section">
      <header>
        <div>
          <h3>Quick Articles</h3>
          <p>FAQ and how-tos</p>
        </div>
        <div className="quick-articles-section__view-all">
          <a
            target="_blank"
            rel="noreferrer"
            href="https://help.workshealth.com"
          >
            View All
          </a>
        </div>
      </header>
      <div className="quick-articles-section__cards">
        <Row gutter={[12, 12]}>
          {loading
            ? iterationMap<ReactNode>(ARTICLES_COUNT, (i: number) => (
                <Col span={8} xl={{ span: 8 }} key={i}>
                  <QuickArticlesCard placeholder />
                </Col>
              ))
            : croppedArticles.map((article) => (
                <Col span={8} xl={{ span: 8 }} key={article.id}>
                  <QuickArticlesCard
                    url={article.url}
                    title={article.title}
                    subtitle={article.subtitle || article.contentSample}
                  />
                </Col>
              ))}
        </Row>
      </div>
      <style jsx>{`
        .quick-articles-section header {
          display: flex;
          justify-content: space-between;
        }
        .quick-articles-section h3 {
          font-size: ${FontSize.xl};
          font-weight: ${FontWeight.medium};
          font-style: normal;
          line-height: ${LineHeight.lg};
          margin-bottom: 0;
        }
        .quick-articles-section a {
          text-decoration: underline;
        }

        .quick-articles-section p {
          margin: 0;
          font-weight: 400;
          line-height: ${LineHeight.md};
          font-style: normal;
          color: ${Colors.steelDarkest};
        }

        .quick-articles-section__view-all {
          display: flex;
          align-items: end;
        }

        .quick-articles-section__cards {
          margin-top: 12px;
        }
      `}</style>
    </div>
  );
}
